import { CookieBanner } from "@microbeta/ui";
import posthog from "posthog-js";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "../../hooks/useAnalytics";

export const CookieConsentBanner = () => {
  const { t } = useTranslation();
  const { getConsent, setConsent } = useAnalytics();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check both cookie and local storage
    const checkConsent = async () => {
      const consent = await getConsent();
      if (!consent) {
        setShowBanner(true);
      } else {
        if (consent.analytics) {
          posthog.opt_in_capturing();
        } else {
          posthog.opt_out_capturing();
        }
      }
    };
    checkConsent();
  }, [getConsent]);

  const handleAccept = async (consent: {
    analytics: boolean;
    marketing: boolean;
  }) => {
    await setConsent(consent);
    setShowBanner(false);
  };

  const handleDecline = async () => {
    await setConsent({ analytics: false, marketing: false });
    setShowBanner(false);
  };

  return (
    <CookieBanner
      isOpen={showBanner}
      onAccept={handleAccept}
      onDecline={handleDecline}
      title={t("cookieBanner.title")}
      description={t("cookieBanner.description")}
      acceptAllLabel={t("cookieBanner.acceptAll")}
      declineLabel={t("cookieBanner.decline")}
      manageLabel={t("cookieBanner.managePreferences")}
      saveLabel={t("cookieBanner.savePreferences")}
      backLabel={t("cookieBanner.back")}
      necessaryLabel={t("cookieBanner.necessary.label")}
      analyticsLabel={t("cookieBanner.analytics.label")}
      marketingLabel={t("cookieBanner.marketing.label")}
      necessaryDescription={t("cookieBanner.necessary.description")}
      analyticsDescription={t("cookieBanner.analytics.description")}
      marketingDescription={t("cookieBanner.marketing.description")}
    />
  );
};
